import { render, staticRenderFns } from "./PaginationNumber.vue?vue&type=template&id=bde9960a&scoped=true"
import script from "./PaginationNumber.vue?vue&type=script&lang=js"
export * from "./PaginationNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde9960a",
  null
  
)

export default component.exports